const state = {
  config: {
    googleMaps: {
      apiKey: 'AIzaSyBNAqPrTQoz9P4NBlDDyfxrnKiafkaL8iQ'
    },
    windowMatchSizeLg: '(min-width: 992px)',
  },
  isLoading: true
}

export default {
  state
}



// WEBPACK FOOTER //
// ./src/store/modules/app.js